import styled from "styled-components";

export const TextFieldStyle = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isTransparent",
})`
  flex-direction: column;
  width: 100%;
  /* margin: 5px 0px; */
  display: ${(props) => (props.inputType !== "const" ? "flex" : "none")};
  fieldset {
    border: 1px solid #080425 !important;
  }
  .MuiInputBase-root {
    width: 100%;
    height: ${(props) => (props.multiline ? "auto" : "36px")};
    background: ${(props) => (props.isTransparent ? "inherit" : "#ffffff")};
    padding: 0 8px;
    font-size: 14px;
    line-height: 21px;
    color: #2b3952;
    display: flex;
    gap: 4px;

    .MuiInputBase-input {
      border: none !important;
      padding: 8px 0;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      padding: 6.5px 11px;
    }
    input {
      padding: 0px !important;
    }
    &.Mui-disabled {
      cursor: default;
      opacity: 0.8;
      /* background: rgba(235, 238, 245, 0.2); */
    }
  }

  .label {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    height: 23px;
    .MuiTypography-root {
      display: flex;
      gap: 5px;
    }
  }

  .MuiFormHelperText-root {
    margin-left: 0px;
    font-size: 11px;
    color: #301d35;
    &.Mui-error {
      color: #d32f2f;
    }
  }

  .MuiAutocomplete-input {
    padding: 2px 4px 7.5px 6px !important;
  }

  .note {
    color: #301d35;
    font-size: 11px;
    font-weight: 400;
  }
`;
